import {useContext} from 'react';
import {MessageDisplayerUtility} from "../MessageDisplayerUtility";
import {LeaveWithoutSavingWarningUtility} from "../LeaveWithoutSavingWarningUtility";
import {GlobalContext} from "../../admin-frame/AdminFrame";
import {useRenderableData} from "./useRenderableData";
import {GenericModel} from "./GenericModel";

// Engine for a wrapper component for a form, where wrapper is in charge of creating models defined by the form
export function useModelCreateEngine(
    modelCreateApiFunction: Function,
    modelName: string,
    createCallback: Function
) {
    const context = useContext(GlobalContext);
    const initialState = {loading: false};
    const createEngineRenderableData = useRenderableData(initialState)

    function createModel(formModelData: object) {
        createEngineRenderableData.updateAndRender({loading: true})
        modelCreateApiFunction(formModelData)
            .then((response: GenericModel) => {
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings(context);
                window.setTimeout(function () {
                    MessageDisplayerUtility.success(`Successfully created ${modelName}.`);
                    if (createCallback) {
                        createCallback(response.id);
                    }
                }, 0)
            })
            .catch((error: object) => {
                createEngineRenderableData.updateAndRender({loading: false})
                console && console.log(error);
                MessageDisplayerUtility.error(`An error occurred while creating the ${modelName}.`);
            })
    }

    return {
        renderableData: createEngineRenderableData,
        createModel: createModel,
    };
}
